// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { HealthcheckHealthcheckGetResponse, LoginLoginPostData, LoginLoginPostResponse, ListUsersListUsersPostResponse, SupahubSsoSupahubSsoPostResponse, LogEventLogEventPostData, LogEventLogEventPostResponse, ContactFormContactFormPostData, ContactFormContactFormPostResponse, TriaSl2VerificationTriaSl2VerificationPostData, TriaSl2VerificationTriaSl2VerificationPostResponse, ListingPdfListingPdfPostData, ListingPdfListingPdfPostResponse, ListingJsonListingJsonPostData, ListingJsonListingJsonPostResponse, GenerateStrPdfFromUrlsGenerateStrPdfFromUrlsPostData, GenerateStrPdfFromUrlsGenerateStrPdfFromUrlsPostResponse, GenerateStrJsonFromUrlsGenerateStrJsonFromUrlsPostData, GenerateStrJsonFromUrlsGenerateStrJsonFromUrlsPostResponse, ContinueCommercialConversationContinueCommercialConversationPostData, ContinueCommercialConversationContinueCommercialConversationPostResponse, AcropolisIngestEmailAcropolisIngestEmailPostData, AcropolisIngestEmailAcropolisIngestEmailPostResponse, BsrUpdateStatusBsrUpdateStatusPostData, BsrUpdateStatusBsrUpdateStatusPostResponse, BsrUpdateAssigneeBsrUpdateAssigneePostData, BsrUpdateAssigneeBsrUpdateAssigneePostResponse, BsrUpdateReportBsrUpdateReportPostData, BsrUpdateReportBsrUpdateReportPostResponse, AcropolisListReportsAcropolisListReportsGetResponse, AcropolisListReportAcropolisListReportReportIdGetData, AcropolisListReportAcropolisListReportReportIdGetResponse, AcropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPostData, AcropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPostResponse, AcropolisValidateUrlAcropolisValidateUrlPostData, AcropolisValidateUrlAcropolisValidateUrlPostResponse, AcropolisDownloadSovAcropolisDownloadSovPostData, AcropolisDownloadSovAcropolisDownloadSovPostResponse, AcropolisDownloadUawAcropolisDownloadUawPostData, AcropolisDownloadUawAcropolisDownloadUawPostResponse, AcropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPostData, AcropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPostResponse, AcropolisDownloadLossRunAcropolisDownloadLossRunPostData, AcropolisDownloadLossRunAcropolisDownloadLossRunPostResponse, AcropolisUpdateReportAcropolisUpdateReportPostData, AcropolisUpdateReportAcropolisUpdateReportPostResponse, AcropolisUpdateAddressAcropolisUpdateAddressPostData, AcropolisUpdateAddressAcropolisUpdateAddressPostResponse, AcropolisCalculate360ValuesAcropolisCalculate360ValuesPostData, AcropolisCalculate360ValuesAcropolisCalculate360ValuesPostResponse, AcropolisDownload360ReportAcropolisDownload360ReportPostData, AcropolisDownload360ReportAcropolisDownload360ReportPostResponse, AcropolisSearchReportAddressesAcropolisSearchReportAddressesPostData, AcropolisSearchReportAddressesAcropolisSearchReportAddressesPostResponse, AcropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPostData, AcropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPostResponse, AcropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPostData, AcropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPostResponse, AcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPostData, AcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPostResponse, AcropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePostData, AcropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePostResponse, GenerateBulkEditAcropolisGenerateBulkEditPostData, GenerateBulkEditAcropolisGenerateBulkEditPostResponse, DownloadReportFileAcropolisDownloadReportFileReportIdFilenameGetData, DownloadReportFileAcropolisDownloadReportFileReportIdFilenameGetResponse, AdonisUploadFilesAdonisUploadFilesPostData, AdonisUploadFilesAdonisUploadFilesPostResponse, RestartBatchAdonisRestartBatchPostData, RestartBatchAdonisRestartBatchPostResponse, DeleteBatchAdonisDeleteBatchPostData, DeleteBatchAdonisDeleteBatchPostResponse, AdonisListBatchesAdonisListBatchesGetResponse, AdonisDownloadPdfsAdonisDownloadPdfsGetData, AdonisDownloadPdfsAdonisDownloadPdfsGetResponse, NdProcessInspectionReportNdProcessInspectionReportPostData, NdProcessInspectionReportNdProcessInspectionReportPostResponse, NdDownloadProcessedReportNdDownloadProcessedReportPostData, NdDownloadProcessedReportNdDownloadProcessedReportPostResponse, WaivoParseRentalHistoryWaivoParseRentalHistoryPostData, WaivoParseRentalHistoryWaivoParseRentalHistoryPostResponse, DentaAnalyzeCodesDentaAnalyzeCodesPostData, DentaAnalyzeCodesDentaAnalyzeCodesPostResponse, DentaFindPossibleCodesDentaFindPossibleCodesPostData, DentaFindPossibleCodesDentaFindPossibleCodesPostResponse, DevDumpCoroutinesDevDumpCoroutinesPostResponse, CheckRunningJobsDevCheckRunningJobsPostResponse, AcropolisListSavedFiltersAcropolisListSavedFiltersPostResponse, AcropolisDeleteSavedFilterAcropolisDeleteSavedFilterPostData, AcropolisDeleteSavedFilterAcropolisDeleteSavedFilterPostResponse, AcropolisUpdateSavedFilterAcropolisUpdateSavedFilterPostData, AcropolisUpdateSavedFilterAcropolisUpdateSavedFilterPostResponse, AcropolisAddSavedFilterAcropolisAddSavedFilterPostData, AcropolisAddSavedFilterAcropolisAddSavedFilterPostResponse, AcropolisLoadAddressesForMapAcropolisLoadAddressesForMapPostResponse } from './types.gen';

/**
 * Healthcheck
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const healthcheckHealthcheckGet = (): CancelablePromise<HealthcheckHealthcheckGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/healthcheck'
}); };

/**
 * Login
 * @param data The data for the request.
 * @param data.formData
 * @returns LoginResponse Successful Response
 * @throws ApiError
 */
export const loginLoginPost = (data: LoginLoginPostData): CancelablePromise<LoginLoginPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/login',
    formData: data.formData,
    mediaType: 'application/x-www-form-urlencoded',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * List Users
 * @returns ListUserResponse Successful Response
 * @throws ApiError
 */
export const listUsersListUsersPost = (): CancelablePromise<ListUsersListUsersPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/list_users'
}); };

/**
 * Supahub Sso
 * @returns SupahubSsoResponse Successful Response
 * @throws ApiError
 */
export const supahubSsoSupahubSsoPost = (): CancelablePromise<SupahubSsoSupahubSsoPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/supahub_sso'
}); };

/**
 * Log Event
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const logEventLogEventPost = (data: LogEventLogEventPostData): CancelablePromise<LogEventLogEventPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/log_event',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Contact Form
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const contactFormContactFormPost = (data: ContactFormContactFormPostData): CancelablePromise<ContactFormContactFormPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/contact_form',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Tria Sl2 Verification
 * @param data The data for the request.
 * @param data.formData
 * @returns Sl2VerificationResponse Successful Response
 * @throws ApiError
 */
export const triaSl2VerificationTriaSl2VerificationPost = (data: TriaSl2VerificationTriaSl2VerificationPostData): CancelablePromise<TriaSl2VerificationTriaSl2VerificationPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/tria/sl2_verification',
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Listing Pdf
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const listingPdfListingPdfPost = (data: ListingPdfListingPdfPostData): CancelablePromise<ListingPdfListingPdfPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/listing_pdf',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Listing Json
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const listingJsonListingJsonPost = (data: ListingJsonListingJsonPostData): CancelablePromise<ListingJsonListingJsonPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/listing_json',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Generate Str Pdf From Urls
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const generateStrPdfFromUrlsGenerateStrPdfFromUrlsPost = (data: GenerateStrPdfFromUrlsGenerateStrPdfFromUrlsPostData): CancelablePromise<GenerateStrPdfFromUrlsGenerateStrPdfFromUrlsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/generate_str_pdf_from_urls',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Generate Str Json From Urls
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const generateStrJsonFromUrlsGenerateStrJsonFromUrlsPost = (data: GenerateStrJsonFromUrlsGenerateStrJsonFromUrlsPostData): CancelablePromise<GenerateStrJsonFromUrlsGenerateStrJsonFromUrlsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/generate_str_json_from_urls',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Continue Commercial Conversation
 * @param data The data for the request.
 * @param data.requestBody
 * @returns CommercialConversationResponse Successful Response
 * @throws ApiError
 */
export const continueCommercialConversationContinueCommercialConversationPost = (data: ContinueCommercialConversationContinueCommercialConversationPostData): CancelablePromise<ContinueCommercialConversationContinueCommercialConversationPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/continue_commercial_conversation',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Ingest Email
 * @param data The data for the request.
 * @param data.formData
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisIngestEmailAcropolisIngestEmailPost = (data: AcropolisIngestEmailAcropolisIngestEmailPostData): CancelablePromise<AcropolisIngestEmailAcropolisIngestEmailPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/ingest_email',
    formData: data.formData,
    mediaType: 'application/x-www-form-urlencoded',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Bsr Update Status
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const bsrUpdateStatusBsrUpdateStatusPost = (data: BsrUpdateStatusBsrUpdateStatusPostData): CancelablePromise<BsrUpdateStatusBsrUpdateStatusPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/bsr/update_status',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Bsr Update Assignee
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const bsrUpdateAssigneeBsrUpdateAssigneePost = (data: BsrUpdateAssigneeBsrUpdateAssigneePostData): CancelablePromise<BsrUpdateAssigneeBsrUpdateAssigneePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/bsr/update_assignee',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Bsr Update Report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const bsrUpdateReportBsrUpdateReportPost = (data: BsrUpdateReportBsrUpdateReportPostData): CancelablePromise<BsrUpdateReportBsrUpdateReportPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/bsr/update_report',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis List Reports
 * @returns ListReportsResponse Successful Response
 * @throws ApiError
 */
export const acropolisListReportsAcropolisListReportsGet = (): CancelablePromise<AcropolisListReportsAcropolisListReportsGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/acropolis/list_reports'
}); };

/**
 * Acropolis List Report
 * @param data The data for the request.
 * @param data.reportId
 * @returns ReportResponse Successful Response
 * @throws ApiError
 */
export const acropolisListReportAcropolisListReportReportIdGet = (data: AcropolisListReportAcropolisListReportReportIdGetData): CancelablePromise<AcropolisListReportAcropolisListReportReportIdGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/acropolis/list_report/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Send Info To Google Sheets
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPost = (data: AcropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPostData): CancelablePromise<AcropolisSendInfoToGoogleSheetsAcropolisSendInfoToGoogleSheetsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/send_info_to_google_sheets',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Validate Url
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ValidateUrlResponse Successful Response
 * @throws ApiError
 */
export const acropolisValidateUrlAcropolisValidateUrlPost = (data: AcropolisValidateUrlAcropolisValidateUrlPostData): CancelablePromise<AcropolisValidateUrlAcropolisValidateUrlPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/validate_url',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Download Sov
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisDownloadSovAcropolisDownloadSovPost = (data: AcropolisDownloadSovAcropolisDownloadSovPostData): CancelablePromise<AcropolisDownloadSovAcropolisDownloadSovPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/download_sov',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Download Uaw
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisDownloadUawAcropolisDownloadUawPost = (data: AcropolisDownloadUawAcropolisDownloadUawPostData): CancelablePromise<AcropolisDownloadUawAcropolisDownloadUawPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/download_uaw',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Generate Underwriting Pdf
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPost = (data: AcropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPostData): CancelablePromise<AcropolisGenerateUnderwritingPdfAcropolisGenerateUnderwritingPdfPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/generate_underwriting_pdf',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Download Loss Run
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisDownloadLossRunAcropolisDownloadLossRunPost = (data: AcropolisDownloadLossRunAcropolisDownloadLossRunPostData): CancelablePromise<AcropolisDownloadLossRunAcropolisDownloadLossRunPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/download_loss_run',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Update Report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdateReportResponse Successful Response
 * @throws ApiError
 */
export const acropolisUpdateReportAcropolisUpdateReportPost = (data: AcropolisUpdateReportAcropolisUpdateReportPostData): CancelablePromise<AcropolisUpdateReportAcropolisUpdateReportPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/update_report',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Update Address
 * @param data The data for the request.
 * @param data.requestBody
 * @returns UpdateAddressResponse Successful Response
 * @throws ApiError
 */
export const acropolisUpdateAddressAcropolisUpdateAddressPost = (data: AcropolisUpdateAddressAcropolisUpdateAddressPostData): CancelablePromise<AcropolisUpdateAddressAcropolisUpdateAddressPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/update_address',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Calculate 360 Values
 * @param data The data for the request.
 * @param data.requestBody
 * @returns Calculate360ValuesResponse Successful Response
 * @throws ApiError
 */
export const acropolisCalculate360ValuesAcropolisCalculate360ValuesPost = (data: AcropolisCalculate360ValuesAcropolisCalculate360ValuesPostData): CancelablePromise<AcropolisCalculate360ValuesAcropolisCalculate360ValuesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/calculate_360_values',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Download 360 Report
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisDownload360ReportAcropolisDownload360ReportPost = (data: AcropolisDownload360ReportAcropolisDownload360ReportPostData): CancelablePromise<AcropolisDownload360ReportAcropolisDownload360ReportPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/download_360_report',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Search Report Addresses
 * @param data The data for the request.
 * @param data.requestBody
 * @returns SearchAddressResponse Successful Response
 * @throws ApiError
 */
export const acropolisSearchReportAddressesAcropolisSearchReportAddressesPost = (data: AcropolisSearchReportAddressesAcropolisSearchReportAddressesPostData): CancelablePromise<AcropolisSearchReportAddressesAcropolisSearchReportAddressesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/search_report_addresses',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis List Additional Files
 * @param data The data for the request.
 * @param data.reportId
 * @returns ListAdditionalFilesResponse Successful Response
 * @throws ApiError
 */
export const acropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPost = (data: AcropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPostData): CancelablePromise<AcropolisListAdditionalFilesAcropolisListAdditionalFilesReportIdPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/list_additional_files/{report_id}',
    path: {
        report_id: data.reportId
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Delete Additional Files
 * @param data The data for the request.
 * @param data.reportId
 * @param data.requestBody
 * @returns DeleteAdditionalFilesResponse Successful Response
 * @throws ApiError
 */
export const acropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPost = (data: AcropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPostData): CancelablePromise<AcropolisDeleteAdditionalFilesAcropolisDeleteAdditionalFilesReportIdPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/delete_additional_files/{report_id}',
    path: {
        report_id: data.reportId
    },
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Upload Additional File
 * @param data The data for the request.
 * @param data.reportId
 * @param data.formData
 * @param data.classificationForAllFiles
 * @param data.sourceForAllFiles
 * @returns UploadAdditionalFilesResponse Successful Response
 * @throws ApiError
 */
export const acropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPost = (data: AcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPostData): CancelablePromise<AcropolisUploadAdditionalFileAcropolisUploadAdditionalFilesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/upload_additional_files',
    query: {
        report_id: data.reportId,
        classification_for_all_files: data.classificationForAllFiles,
        source_for_all_files: data.sourceForAllFiles
    },
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Download Additional File
 * @param data The data for the request.
 * @param data.requestBody
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const acropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePost = (data: AcropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePostData): CancelablePromise<AcropolisDownloadAdditionalFileAcropolisDownloadAdditionalFilePostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/download_additional_file',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Generate Bulk Edit
 * @param data The data for the request.
 * @param data.requestBody
 * @returns BulkEditResponse Successful Response
 * @throws ApiError
 */
export const generateBulkEditAcropolisGenerateBulkEditPost = (data: GenerateBulkEditAcropolisGenerateBulkEditPostData): CancelablePromise<GenerateBulkEditAcropolisGenerateBulkEditPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/generate_bulk_edit',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Download Report File
 * @param data The data for the request.
 * @param data.reportId
 * @param data.filename
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const downloadReportFileAcropolisDownloadReportFileReportIdFilenameGet = (data: DownloadReportFileAcropolisDownloadReportFileReportIdFilenameGetData): CancelablePromise<DownloadReportFileAcropolisDownloadReportFileReportIdFilenameGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/acropolis/download_report_file/{report_id}/{filename}',
    path: {
        report_id: data.reportId,
        filename: data.filename
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Adonis Upload Files
 * @param data The data for the request.
 * @param data.formData
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const adonisUploadFilesAdonisUploadFilesPost = (data: AdonisUploadFilesAdonisUploadFilesPostData): CancelablePromise<AdonisUploadFilesAdonisUploadFilesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/adonis/upload_files',
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Restart Batch
 * @param data The data for the request.
 * @param data.epoch
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const restartBatchAdonisRestartBatchPost = (data: RestartBatchAdonisRestartBatchPostData): CancelablePromise<RestartBatchAdonisRestartBatchPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/adonis/restart_batch',
    query: {
        epoch: data.epoch
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Delete Batch
 * @param data The data for the request.
 * @param data.epoch
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const deleteBatchAdonisDeleteBatchPost = (data: DeleteBatchAdonisDeleteBatchPostData): CancelablePromise<DeleteBatchAdonisDeleteBatchPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/adonis/delete_batch',
    query: {
        epoch: data.epoch
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Adonis List Batches
 * @returns ListBatchesResponse Successful Response
 * @throws ApiError
 */
export const adonisListBatchesAdonisListBatchesGet = (): CancelablePromise<AdonisListBatchesAdonisListBatchesGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/adonis/list_batches'
}); };

/**
 * Adonis Download Pdfs
 * @param data The data for the request.
 * @param data.folderName
 * @returns unknown Successful Response
 * @throws ApiError
 */
export const adonisDownloadPdfsAdonisDownloadPdfsGet = (data: AdonisDownloadPdfsAdonisDownloadPdfsGetData): CancelablePromise<AdonisDownloadPdfsAdonisDownloadPdfsGetResponse> => { return __request(OpenAPI, {
    method: 'GET',
    url: '/adonis/download_pdfs',
    query: {
        folder_name: data.folderName
    },
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Process Inspection Report
 * Use this API to upload inspection reports. The metadata parameter should contain a stringified JSON object that matches the following schema:
 * ```json
 * {
 * "betterview_pdf_link": "tower.betterview.com/property-profile/13664298/pdf?hash=490AFD16-6119-45D8-881C-48E4C967B0DA",
 * "line_of_business": "ho",
 * "residence_type": "primary",
 * "policy_squate_footage": 2500
 * }
 * ```
 *
 *
 * An example response might be
 * ```json
 * {
 * "policy_number": "D0360513",
 * "output_filename": "1744832002_processed/D0360513_INSPECTION_REPORT_5352248_pantheon.pdf",
 * "hazards": [
 * {
 * "name": "Above ground pool without locked fence",
 * "explanation": "There is an above ground pool without a fence around it.",
 * "severity": 3
 * }
 * ],
 * "is_flagged": true,
 * "non_renewal": false,
 * "rec_letter": true,
 * "itv_flag": false,
 * "itv_percentage": 95.3,
 * "policy_coverage_a": 425000,
 * "inspection_coverage_a": 431000,
 * "policy_square_footage": 2500,
 * "inspection_square_footage": 2230,
 * "total_hazard_score": 3
 * }
 * ```
 * @param data The data for the request.
 * @param data.formData
 * @returns ProcessInspectionReportResponse Successful Response
 * @throws ApiError
 */
export const ndProcessInspectionReportNdProcessInspectionReportPost = (data: NdProcessInspectionReportNdProcessInspectionReportPostData): CancelablePromise<NdProcessInspectionReportNdProcessInspectionReportPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/nd/process_inspection_report',
    formData: data.formData,
    mediaType: 'multipart/form-data',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Download Processed Report
 * Use this API to download finished inspection reports. The filename parameter should be provided from the response of `/nd/process_inspection_report`
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string Successful Response
 * @throws ApiError
 */
export const ndDownloadProcessedReportNdDownloadProcessedReportPost = (data: NdDownloadProcessedReportNdDownloadProcessedReportPostData): CancelablePromise<NdDownloadProcessedReportNdDownloadProcessedReportPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/nd/download_processed_report',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Waivo Parse Rental History
 * @param data The data for the request.
 * @param data.requestBody
 * @returns string Successful Response
 * @throws ApiError
 */
export const waivoParseRentalHistoryWaivoParseRentalHistoryPost = (data: WaivoParseRentalHistoryWaivoParseRentalHistoryPostData): CancelablePromise<WaivoParseRentalHistoryWaivoParseRentalHistoryPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/waivo/parse_rental_history',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Denta Analyze Codes
 * @param data The data for the request.
 * @param data.requestBody
 * @returns AnalyzeCodesResponse Successful Response
 * @throws ApiError
 */
export const dentaAnalyzeCodesDentaAnalyzeCodesPost = (data: DentaAnalyzeCodesDentaAnalyzeCodesPostData): CancelablePromise<DentaAnalyzeCodesDentaAnalyzeCodesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/denta/analyze_codes',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Denta Find Possible Codes
 * @param data The data for the request.
 * @param data.requestBody
 * @returns FindPossibleCodesResponse Successful Response
 * @throws ApiError
 */
export const dentaFindPossibleCodesDentaFindPossibleCodesPost = (data: DentaFindPossibleCodesDentaFindPossibleCodesPostData): CancelablePromise<DentaFindPossibleCodesDentaFindPossibleCodesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/denta/find_possible_codes',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Dev Dump Coroutines
 * @returns string Successful Response
 * @throws ApiError
 */
export const devDumpCoroutinesDevDumpCoroutinesPost = (): CancelablePromise<DevDumpCoroutinesDevDumpCoroutinesPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/dev/dump_coroutines'
}); };

/**
 * Check Running Jobs
 * @returns string Successful Response
 * @throws ApiError
 */
export const checkRunningJobsDevCheckRunningJobsPost = (): CancelablePromise<CheckRunningJobsDevCheckRunningJobsPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/dev/check_running_jobs'
}); };

/**
 * Acropolis List Saved Filters
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const acropolisListSavedFiltersAcropolisListSavedFiltersPost = (): CancelablePromise<AcropolisListSavedFiltersAcropolisListSavedFiltersPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/list_saved_filters'
}); };

/**
 * Acropolis Delete Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const acropolisDeleteSavedFilterAcropolisDeleteSavedFilterPost = (data: AcropolisDeleteSavedFilterAcropolisDeleteSavedFilterPostData): CancelablePromise<AcropolisDeleteSavedFilterAcropolisDeleteSavedFilterPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/delete_saved_filter',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Update Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const acropolisUpdateSavedFilterAcropolisUpdateSavedFilterPost = (data: AcropolisUpdateSavedFilterAcropolisUpdateSavedFilterPostData): CancelablePromise<AcropolisUpdateSavedFilterAcropolisUpdateSavedFilterPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/update_saved_filter',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Add Saved Filter
 * @param data The data for the request.
 * @param data.requestBody
 * @returns ListSavedFiltersResponse Successful Response
 * @throws ApiError
 */
export const acropolisAddSavedFilterAcropolisAddSavedFilterPost = (data: AcropolisAddSavedFilterAcropolisAddSavedFilterPostData): CancelablePromise<AcropolisAddSavedFilterAcropolisAddSavedFilterPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/add_saved_filter',
    body: data.requestBody,
    mediaType: 'application/json',
    errors: {
        422: 'Validation Error'
    }
}); };

/**
 * Acropolis Load Addresses For Map
 * @returns LoadAddressesForMapResponse Successful Response
 * @throws ApiError
 */
export const acropolisLoadAddressesForMapAcropolisLoadAddressesForMapPost = (): CancelablePromise<AcropolisLoadAddressesForMapAcropolisLoadAddressesForMapPostResponse> => { return __request(OpenAPI, {
    method: 'POST',
    url: '/acropolis/load_addresses_for_map'
}); };